import React from 'react';
import './privacidade.css'


const Privacidade = () => {
    return(
        <div className='policy'>
            <div className='header'>
                <div className='titulo'>Privacy Policy of Calculadora Mulemba</div>
            </div>
                <div className='texto'>
                    <div className='one'>This application does not collect any Personal Data from its users</div>
                    <div className='two'>Este documento pode ser imprimido para servir como referencia</div>
                </div>
            <div className='header'>
                <div className='titulo'>Policy Sumarry</div>
            </div>
                <div className='texto'>
                    <div>No data is collected by this app</div>
                    <div className='contacto'>Contact Information</div>
                        <div className='info'>
                            <div>Owner and Data Controller</div>
                            <div>Perspectiva, tech</div>
                            <div>Luena, Moxico</div>
                            <div>Moxico Angola</div>
                            <div>Owner contact email: miltoncsedev@gmail.com</div>
                        </div>
                </div>
            <div className='footer'>Last update: 21 November 2022</div>
        </div>
    );
}

export default Privacidade;